import { UnitValueDto } from '@vpfa/rest-api/valuation';

export const unitValueComparator = (valueA: UnitValueDto, valueB: UnitValueDto) => {
  const a = valueA ? valueA.value : 0;
  const b = valueB ? valueB.value : 0;
  return a - b;
};
